import { Box, Stepper, Step, StepLabel, Button, Grid } from "@mui/material";
import React from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../hooks/store-hooks";
import { usePasswordRecoveryService } from "../../../../use-cases/auth/usePasswordRecoveryService";

const steps = ['Solicitar nova senha', 'Validar código', 'Redefinir a senha'];
export const PasswordRecoveryLayout = () => {
  const activeStep = useAppSelector((state) => state.auth.currentPasswordRecoveryStep)
  const {
    requestNewPassword,
    validateCode,
    createNewPassword,
    prevStep
  } = usePasswordRecoveryService()
  const navigate = useNavigate()
  return <>
    <Box sx={{ width: '100%' }}>
      <Stepper activeStep={activeStep}>
        {steps.map((label, index) => {
          const stepProps: { completed?: boolean } = {};
          const labelProps: {
            optional?: React.ReactNode;
          } = {};

          return (
            <Step key={label} {...stepProps}>
              <StepLabel {...labelProps}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>

      <React.Fragment>
        <Box my={3}>
          <Outlet />
        </Box>
        {/* {
            formError && (
              <Box sx={{ mt: 3 }}>
                <Typography color="error" align="center">
                  {formError.message}
                </Typography>
              </Box>
            )
          } */}
        <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
          <Button
            color="inherit"
            disabled={activeStep === 0}
            onClick={prevStep}
            sx={{ mr: 1 }}
          >
            Voltar
          </Button>
          <Box sx={{ flex: '1 1 auto' }} />

          <Button onClick={() => {
            if (activeStep === 0) {
              requestNewPassword()
            } else if (activeStep === 1) {
              validateCode()
            } else if (activeStep === 2) {
              createNewPassword()
            }
          }}>
            {activeStep === steps.length - 1 ? 'Enviar' : 'Próximo'}
          </Button>
        </Box>
        <Grid container justifyContent={"center"}>
          <Grid item>
            <Button
              onClick={() => {
                navigate('/auth/login')
              }}
              sx={{
                mt: 3,
                color: 'primary.main',
                fontWeight: 'bold',
                textTransform: 'none',
                fontSize: '1rem',
              }}
            >
              Clique aqui para fazer login
            </Button>


          </Grid>
        </Grid>
      </React.Fragment>

    </Box>

  </>
}